export default __webpack_public_path__ + "media/images/new-favicon-1f7f56de8ac7e4a2b6918b5df842b8dd.svg";